module.exports = __webpack_public_path__ + "static/Danzza-Medium-4892ef5c6de6ac4f4d4beeb0b713ff9c.woff";